export const COLUMN_WIDTH_STATUS = 141;
export const COLUMN_WIDTH_CANDIDATES = 137;
export const COLUMN_WIDTH_CANDIDATE_MATCHES = 172;
export const COLUMN_WIDTH_PERFORMANCE = 164;
export const COLUMN_WIDTH_CTA = 350;

export const OVERFLOW_MENU_ICON_WIDTH = 16;

export const EmDash = '–';
